import React from "react";

export default function vendorDetail() {
  return (
    <div>
      <main className="main">
        <div className="page-header breadcrumb-wrap">
          <div className="container">
            <div className="breadcrumb">
              <a rel="nofollow">
                <i className="fi-rs-home mr-5" />
                Home
              </a>
              <span /> Store <span /> Nest Food
            </div>
          </div>
        </div>
        <div className="container mb-30">
          <div className="archive-header-2 text-center pt-80 pb-50">
            <h1 className="display-2 mb-50">Nest Food Store</h1>
            <div className="row">
              <div className="col-lg-5 mx-auto">
                <div className="sidebar-widget-2 widget_search mb-50">
                  <div className="search-form">
                    <form action="#">
                      <input
                        type="text"
                        placeholder="Search in this store..."
                      />
                      <button type="submit">
                        <i className="fi-rs-search" />
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row flex-row-reverse">
            <div className="col-lg-4-5">
              <div className="shop-product-fillter">
                <div className="totall-product">
                  <p>
                    We found <strong className="text-brand">29</strong> items
                    for you!
                  </p>
                </div>
                <div className="sort-by-product-area">
                  <div className="sort-by-cover mr-10">
                    <div className="sort-by-product-wrap">
                      <div className="sort-by">
                        <span>
                          <i className="fi-rs-apps" />
                          Show:
                        </span>
                      </div>
                      <div className="sort-by-dropdown-wrap">
                        <span>
                          {" "}
                          50 <i className="fi-rs-angle-small-down" />
                        </span>
                      </div>
                    </div>
                    <div className="sort-by-dropdown">
                      <ul>
                        <li>
                          <a className="active">50</a>
                        </li>
                        <li>
                          <a>100</a>
                        </li>
                        <li>
                          <a>150</a>
                        </li>
                        <li>
                          <a>200</a>
                        </li>
                        <li>
                          <a>All</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="sort-by-cover">
                    <div className="sort-by-product-wrap">
                      <div className="sort-by">
                        <span>
                          <i className="fi-rs-apps-sort" />
                          Sort by:
                        </span>
                      </div>
                      <div className="sort-by-dropdown-wrap">
                        <span>
                          Featured <i className="fi-rs-angle-small-down" />
                        </span>
                      </div>
                    </div>
                    <div className="sort-by-dropdown">
                      <ul>
                        <li>
                          <a className="active">Featured</a>
                        </li>
                        <li>
                          <a>Price: Low to High</a>
                        </li>
                        <li>
                          <a>Price: High to Low</a>
                        </li>
                        <li>
                          <a>Release Date</a>
                        </li>
                        <li>
                          <a>Avg. Rating</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row product-grid">
                <div className="col-lg-1-5 col-md-4 col-12 col-sm-6">
                  <div className="product-cart-wrap mb-30">
                    <div className="product-img-action-wrap">
                      <div className="product-img product-img-zoom">
                        <a>
                          <img
                            className="default-img"
                            src="assets/imgs/shop/product-1-1.jpg"
                            alt=""
                          />
                          <img
                            className="hover-img"
                            src="assets/imgs/shop/product-1-2.jpg"
                            alt=""
                          />
                        </a>
                      </div>
                      <div className="product-action-1">
                        <a aria-label="Add To Wishlist" className="action-btn">
                          <i className="fi-rs-heart" />
                        </a>
                        <a aria-label="Compare" className="action-btn">
                          <i className="fi-rs-shuffle" />
                        </a>
                        <a
                          aria-label="Quick view"
                          className="action-btn"
                          data-bs-toggle="modal"
                          data-bs-target="#quickViewModal"
                        >
                          <i className="fi-rs-eye" />
                        </a>
                      </div>
                      <div className="product-badges product-badges-position product-badges-mrg">
                        <span className="hot">Hot</span>
                      </div>
                    </div>
                    <div className="product-content-wrap">
                      <div className="product-category">
                        <a>Snack</a>
                      </div>
                      <h2>
                        <a>Seeds of Change Organic Quinoe</a>
                      </h2>
                      <div className="product-rate-cover">
                        <div className="product-rate d-inline-block">
                          <div
                            className="product-rating"
                            style={{ width: "90%" }}
                          />
                        </div>
                        <span className="font-small ml-5 text-muted">
                          {" "}
                          (4.0)
                        </span>
                      </div>
                      <div>
                        <span className="font-small text-muted">
                          By <a>NestFood</a>
                        </span>
                      </div>
                      <div className="product-card-bottom">
                        <div className="product-price">
                          <span>$28.85</span>
                          <span className="old-price">$32.8</span>
                        </div>
                        <div className="add-cart">
                          <a className="add">
                            <i className="fi-rs-shopping-cart mr-5" />
                            Add
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/*end product card*/}
                <div className="col-lg-1-5 col-md-4 col-12 col-sm-6">
                  <div className="product-cart-wrap mb-30">
                    <div className="product-img-action-wrap">
                      <div className="product-img product-img-zoom">
                        <a>
                          <img
                            className="default-img"
                            src="assets/imgs/shop/product-2-1.jpg"
                            alt=""
                          />
                          <img
                            className="hover-img"
                            src="assets/imgs/shop/product-2-2.jpg"
                            alt=""
                          />
                        </a>
                      </div>
                      <div className="product-action-1">
                        <a aria-label="Add To Wishlist" className="action-btn">
                          <i className="fi-rs-heart" />
                        </a>
                        <a aria-label="Compare" className="action-btn">
                          <i className="fi-rs-shuffle" />
                        </a>
                        <a
                          aria-label="Quick view"
                          className="action-btn"
                          data-bs-toggle="modal"
                          data-bs-target="#quickViewModal"
                        >
                          <i className="fi-rs-eye" />
                        </a>
                      </div>
                      <div className="product-badges product-badges-position product-badges-mrg">
                        <span className="sale">Sale</span>
                      </div>
                    </div>
                    <div className="product-content-wrap">
                      <div className="product-category">
                        <a>Hodo Foods</a>
                      </div>
                      <h2>
                        <a>All Natural Italian-Style Chicken Meatballs</a>
                      </h2>
                      <div className="product-rate-cover">
                        <div className="product-rate d-inline-block">
                          <div
                            className="product-rating"
                            style={{ width: "80%" }}
                          />
                        </div>
                        <span className="font-small ml-5 text-muted">
                          {" "}
                          (3.5)
                        </span>
                      </div>
                      <div>
                        <span className="font-small text-muted">
                          By <a>Stouffer</a>
                        </span>
                      </div>
                      <div className="product-card-bottom">
                        <div className="product-price">
                          <span>$52.85</span>
                          <span className="old-price">$55.8</span>
                        </div>
                        <div className="add-cart">
                          <a className="add">
                            <i className="fi-rs-shopping-cart mr-5" />
                            Add
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/*end product card*/}
                <div className="col-lg-1-5 col-md-4 col-12 col-sm-6">
                  <div className="product-cart-wrap mb-30">
                    <div className="product-img-action-wrap">
                      <div className="product-img product-img-zoom">
                        <a>
                          <img
                            className="default-img"
                            src="assets/imgs/shop/product-3-1.jpg"
                            alt=""
                          />
                          <img
                            className="hover-img"
                            src="assets/imgs/shop/product-3-2.jpg"
                            alt=""
                          />
                        </a>
                      </div>
                      <div className="product-action-1">
                        <a aria-label="Add To Wishlist" className="action-btn">
                          <i className="fi-rs-heart" />
                        </a>
                        <a aria-label="Compare" className="action-btn">
                          <i className="fi-rs-shuffle" />
                        </a>
                        <a
                          aria-label="Quick view"
                          className="action-btn"
                          data-bs-toggle="modal"
                          data-bs-target="#quickViewModal"
                        >
                          <i className="fi-rs-eye" />
                        </a>
                      </div>
                      <div className="product-badges product-badges-position product-badges-mrg">
                        <span className="new">New</span>
                      </div>
                    </div>
                    <div className="product-content-wrap">
                      <div className="product-category">
                        <a>Snack</a>
                      </div>
                      <h2>
                        <a>Angie’s Boomchickapop Sweet &amp; Salty</a>
                      </h2>
                      <div className="product-rate-cover">
                        <div className="product-rate d-inline-block">
                          <div
                            className="product-rating"
                            style={{ width: "85%" }}
                          />
                        </div>
                        <span className="font-small ml-5 text-muted">
                          {" "}
                          (4.0)
                        </span>
                      </div>
                      <div>
                        <span className="font-small text-muted">
                          By <a>StarKist</a>
                        </span>
                      </div>
                      <div className="product-card-bottom">
                        <div className="product-price">
                          <span>$48.85</span>
                          <span className="old-price">$52.8</span>
                        </div>
                        <div className="add-cart">
                          <a className="add">
                            <i className="fi-rs-shopping-cart mr-5" />
                            Add
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/*end product card*/}
                <div className="col-lg-1-5 col-md-4 col-12 col-sm-6">
                  <div className="product-cart-wrap mb-30">
                    <div className="product-img-action-wrap">
                      <div className="product-img product-img-zoom">
                        <a>
                          <img
                            className="default-img"
                            src="assets/imgs/shop/product-4-1.jpg"
                            alt=""
                          />
                          <img
                            className="hover-img"
                            src="assets/imgs/shop/product-4-2.jpg"
                            alt=""
                          />
                        </a>
                      </div>
                      <div className="product-action-1">
                        <a aria-label="Add To Wishlist" className="action-btn">
                          <i className="fi-rs-heart" />
                        </a>
                        <a aria-label="Compare" className="action-btn">
                          <i className="fi-rs-shuffle" />
                        </a>
                        <a
                          aria-label="Quick view"
                          className="action-btn"
                          data-bs-toggle="modal"
                          data-bs-target="#quickViewModal"
                        >
                          <i className="fi-rs-eye" />
                        </a>
                      </div>
                    </div>
                    <div className="product-content-wrap">
                      <div className="product-category">
                        <a>Vegetables</a>
                      </div>
                      <h2>
                        <a>Foster Farms Takeout Crispy Classic</a>
                      </h2>
                      <div className="product-rate-cover">
                        <div className="product-rate d-inline-block">
                          <div
                            className="product-rating"
                            style={{ width: "90%" }}
                          />
                        </div>
                        <span className="font-small ml-5 text-muted">
                          {" "}
                          (4.0)
                        </span>
                      </div>
                      <div>
                        <span className="font-small text-muted">
                          By <a>NestFood</a>
                        </span>
                      </div>
                      <div className="product-card-bottom">
                        <div className="product-price">
                          <span>$17.85</span>
                          <span className="old-price">$19.8</span>
                        </div>
                        <div className="add-cart">
                          <a className="add">
                            <i className="fi-rs-shopping-cart mr-5" />
                            Add
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/*end product card*/}
                <div className="col-lg-1-5 col-md-4 col-12 col-sm-6">
                  <div className="product-cart-wrap mb-30">
                    <div className="product-img-action-wrap">
                      <div className="product-img product-img-zoom">
                        <a>
                          <img
                            className="default-img"
                            src="assets/imgs/shop/product-5-1.jpg"
                            alt=""
                          />
                          <img
                            className="hover-img"
                            src="assets/imgs/shop/product-5-2.jpg"
                            alt=""
                          />
                        </a>
                      </div>
                      <div className="product-action-1">
                        <a aria-label="Add To Wishlist" className="action-btn">
                          <i className="fi-rs-heart" />
                        </a>
                        <a aria-label="Compare" className="action-btn">
                          <i className="fi-rs-shuffle" />
                        </a>
                        <a
                          aria-label="Quick view"
                          className="action-btn"
                          data-bs-toggle="modal"
                          data-bs-target="#quickViewModal"
                        >
                          <i className="fi-rs-eye" />
                        </a>
                      </div>
                      <div className="product-badges product-badges-position product-badges-mrg">
                        <span className="best">-14%</span>
                      </div>
                    </div>
                    <div className="product-content-wrap">
                      <div className="product-category">
                        <a>Pet Foods</a>
                      </div>
                      <h2>
                        <a>Blue Diamond Almonds Lightly</a>
                      </h2>
                      <div className="product-rate-cover">
                        <div className="product-rate d-inline-block">
                          <div
                            className="product-rating"
                            style={{ width: "90%" }}
                          />
                        </div>
                        <span className="font-small ml-5 text-muted">
                          {" "}
                          (4.0)
                        </span>
                      </div>
                      <div>
                        <span className="font-small text-muted">
                          By <a>NestFood</a>
                        </span>
                      </div>
                      <div className="product-card-bottom">
                        <div className="product-price">
                          <span>$23.85</span>
                          <span className="old-price">$25.8</span>
                        </div>
                        <div className="add-cart">
                          <a className="add">
                            <i className="fi-rs-shopping-cart mr-5" />
                            Add
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/*end product card*/}
                <div className="col-lg-1-5 col-md-4 col-12 col-sm-6">
                  <div className="product-cart-wrap mb-30">
                    <div className="product-img-action-wrap">
                      <div className="product-img product-img-zoom">
                        <a>
                          <img
                            className="default-img"
                            src="assets/imgs/shop/product-6-1.jpg"
                            alt=""
                          />
                          <img
                            className="hover-img"
                            src="assets/imgs/shop/product-6-2.jpg"
                            alt=""
                          />
                        </a>
                      </div>
                      <div className="product-action-1">
                        <a aria-label="Add To Wishlist" className="action-btn">
                          <i className="fi-rs-heart" />
                        </a>
                        <a aria-label="Compare" className="action-btn">
                          <i className="fi-rs-shuffle" />
                        </a>
                        <a
                          aria-label="Quick view"
                          className="action-btn"
                          data-bs-toggle="modal"
                          data-bs-target="#quickViewModal"
                        >
                          <i className="fi-rs-eye" />
                        </a>
                      </div>
                    </div>
                    <div className="product-content-wrap">
                      <div className="product-category">
                        <a>Hodo Foods</a>
                      </div>
                      <h2>
                        <a>Chobani Complete Vanilla Greek</a>
                      </h2>
                      <div className="product-rate-cover">
                        <div className="product-rate d-inline-block">
                          <div
                            className="product-rating"
                            style={{ width: "90%" }}
                          />
                        </div>
                        <span className="font-small ml-5 text-muted">
                          {" "}
                          (4.0)
                        </span>
                      </div>
                      <div>
                        <span className="font-small text-muted">
                          By <a>NestFood</a>
                        </span>
                      </div>
                      <div className="product-card-bottom">
                        <div className="product-price">
                          <span>$54.85</span>
                          <span className="old-price">$55.8</span>
                        </div>
                        <div className="add-cart">
                          <a className="add">
                            <i className="fi-rs-shopping-cart mr-5" />
                            Add
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/*end product card*/}
                <div className="col-lg-1-5 col-md-4 col-12 col-sm-6">
                  <div className="product-cart-wrap mb-30">
                    <div className="product-img-action-wrap">
                      <div className="product-img product-img-zoom">
                        <a>
                          <img
                            className="default-img"
                            src="assets/imgs/shop/product-7-1.jpg"
                            alt=""
                          />
                          <img
                            className="hover-img"
                            src="assets/imgs/shop/product-7-2.jpg"
                            alt=""
                          />
                        </a>
                      </div>
                      <div className="product-action-1">
                        <a aria-label="Add To Wishlist" className="action-btn">
                          <i className="fi-rs-heart" />
                        </a>
                        <a aria-label="Compare" className="action-btn">
                          <i className="fi-rs-shuffle" />
                        </a>
                        <a
                          aria-label="Quick view"
                          className="action-btn"
                          data-bs-toggle="modal"
                          data-bs-target="#quickViewModal"
                        >
                          <i className="fi-rs-eye" />
                        </a>
                      </div>
                    </div>
                    <div className="product-content-wrap">
                      <div className="product-category">
                        <a>Meats</a>
                      </div>
                      <h2>
                        <a>Canada Dry Ginger Ale – 2 L Bottle</a>
                      </h2>
                      <div className="product-rate-cover">
                        <div className="product-rate d-inline-block">
                          <div
                            className="product-rating"
                            style={{ width: "90%" }}
                          />
                        </div>
                        <span className="font-small ml-5 text-muted">
                          {" "}
                          (4.0)
                        </span>
                      </div>
                      <div>
                        <span className="font-small text-muted">
                          By <a>NestFood</a>
                        </span>
                      </div>
                      <div className="product-card-bottom">
                        <div className="product-price">
                          <span>$32.85</span>
                          <span className="old-price">$33.8</span>
                        </div>
                        <div className="add-cart">
                          <a className="add">
                            <i className="fi-rs-shopping-cart mr-5" />
                            Add
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/*end product card*/}
                <div className="col-lg-1-5 col-md-4 col-12 col-sm-6">
                  <div className="product-cart-wrap mb-30">
                    <div className="product-img-action-wrap">
                      <div className="product-img product-img-zoom">
                        <a>
                          <img
                            className="default-img"
                            src="assets/imgs/shop/product-8-1.jpg"
                            alt=""
                          />
                          <img
                            className="hover-img"
                            src="assets/imgs/shop/product-8-2.jpg"
                            alt=""
                          />
                        </a>
                      </div>
                      <div className="product-action-1">
                        <a aria-label="Add To Wishlist" className="action-btn">
                          <i className="fi-rs-heart" />
                        </a>
                        <a aria-label="Compare" className="action-btn">
                          <i className="fi-rs-shuffle" />
                        </a>
                        <a
                          aria-label="Quick view"
                          className="action-btn"
                          data-bs-toggle="modal"
                          data-bs-target="#quickViewModal"
                        >
                          <i className="fi-rs-eye" />
                        </a>
                      </div>
                      <div className="product-badges product-badges-position product-badges-mrg">
                        <span className="sale">Sale</span>
                      </div>
                    </div>
                    <div className="product-content-wrap">
                      <div className="product-category">
                        <a>Snack</a>
                      </div>
                      <h2>
                        <a>Encore Seafoods Stuffed Alaskan</a>
                      </h2>
                      <div className="product-rate-cover">
                        <div className="product-rate d-inline-block">
                          <div
                            className="product-rating"
                            style={{ width: "90%" }}
                          />
                        </div>
                        <span className="font-small ml-5 text-muted">
                          {" "}
                          (4.0)
                        </span>
                      </div>
                      <div>
                        <span className="font-small text-muted">
                          By <a>NestFood</a>
                        </span>
                      </div>
                      <div className="product-card-bottom">
                        <div className="product-price">
                          <span>$35.85</span>
                          <span className="old-price">$37.8</span>
                        </div>
                        <div className="add-cart">
                          <a className="add">
                            <i className="fi-rs-shopping-cart mr-5" />
                            Add
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/*end product card*/}
                <div className="col-lg-1-5 col-md-4 col-12 col-sm-6">
                  <div className="product-cart-wrap mb-30">
                    <div className="product-img-action-wrap">
                      <div className="product-img product-img-zoom">
                        <a>
                          <img
                            className="default-img"
                            src="assets/imgs/shop/product-9-1.jpg"
                            alt=""
                          />
                          <img
                            className="hover-img"
                            src="assets/imgs/shop/product-9-2.jpg"
                            alt=""
                          />
                        </a>
                      </div>
                      <div className="product-action-1">
                        <a aria-label="Add To Wishlist" className="action-btn">
                          <i className="fi-rs-heart" />
                        </a>
                        <a aria-label="Compare" className="action-btn">
                          <i className="fi-rs-shuffle" />
                        </a>
                        <a
                          aria-label="Quick view"
                          className="action-btn"
                          data-bs-toggle="modal"
                          data-bs-target="#quickViewModal"
                        >
                          <i className="fi-rs-eye" />
                        </a>
                      </div>
                      <div className="product-badges product-badges-position product-badges-mrg">
                        <span className="hot">Hot</span>
                      </div>
                    </div>
                    <div className="product-content-wrap">
                      <div className="product-category">
                        <a>Coffes</a>
                      </div>
                      <h2>
                        <a>Gorton’s Beer Battered Fish Fillets</a>
                      </h2>
                      <div className="product-rate-cover">
                        <div className="product-rate d-inline-block">
                          <div
                            className="product-rating"
                            style={{ width: "90%" }}
                          />
                        </div>
                        <span className="font-small ml-5 text-muted">
                          {" "}
                          (4.0)
                        </span>
                      </div>
                      <div>
                        <span className="font-small text-muted">
                          By
                          <a>Old El Paso</a>
                        </span>
                      </div>
                      <div className="product-card-bottom">
                        <div className="product-price">
                          <span>$23.85</span>
                          <span className="old-price">$25.8</span>
                        </div>
                        <div className="add-cart">
                          <a className="add">
                            <i className="fi-rs-shopping-cart mr-5" />
                            Add
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/*end product card*/}
                <div className="col-lg-1-5 col-md-4 col-12 col-sm-6 d-none d-xl-block">
                  <div className="product-cart-wrap mb-30">
                    <div className="product-img-action-wrap">
                      <div className="product-img product-img-zoom">
                        <a>
                          <img
                            className="default-img"
                            src="assets/imgs/shop/product-10-1.jpg"
                            alt=""
                          />
                          <img
                            className="hover-img"
                            src="assets/imgs/shop/product-10-2.jpg"
                            alt=""
                          />
                        </a>
                      </div>
                      <div className="product-action-1">
                        <a aria-label="Add To Wishlist" className="action-btn">
                          <i className="fi-rs-heart" />
                        </a>
                        <a aria-label="Compare" className="action-btn">
                          <i className="fi-rs-shuffle" />
                        </a>
                        <a
                          aria-label="Quick view"
                          className="action-btn"
                          data-bs-toggle="modal"
                          data-bs-target="#quickViewModal"
                        >
                          <i className="fi-rs-eye" />
                        </a>
                      </div>
                    </div>
                    <div className="product-content-wrap">
                      <div className="product-category">
                        <a>Cream</a>
                      </div>
                      <h2>
                        <a>Haagen-Dazs Caramel Cone Ice Cream</a>
                      </h2>
                      <div className="product-rate-cover">
                        <div className="product-rate d-inline-block">
                          <div
                            className="product-rating"
                            style={{ width: "50%" }}
                          />
                        </div>
                        <span className="font-small ml-5 text-muted">
                          {" "}
                          (2.0)
                        </span>
                      </div>
                      <div>
                        <span className="font-small text-muted">
                          By <a>Tyson</a>
                        </span>
                      </div>
                      <div className="product-card-bottom">
                        <div className="product-price">
                          <span>$22.85</span>
                          <span className="old-price">$24.8</span>
                        </div>
                        <div className="add-cart">
                          <a className="add">
                            <i className="fi-rs-shopping-cart mr-5" />
                            Add
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/*end product card*/}
                <div className="col-lg-1-5 col-md-4 col-12 col-sm-6">
                  <div className="product-cart-wrap mb-30">
                    <div className="product-img-action-wrap">
                      <div className="product-img product-img-zoom">
                        <a>
                          <img
                            className="default-img"
                            src="assets/imgs/shop/product-1-1.jpg"
                            alt=""
                          />
                          <img
                            className="hover-img"
                            src="assets/imgs/shop/product-1-2.jpg"
                            alt=""
                          />
                        </a>
                      </div>
                      <div className="product-action-1">
                        <a aria-label="Add To Wishlist" className="action-btn">
                          <i className="fi-rs-heart" />
                        </a>
                        <a aria-label="Compare" className="action-btn">
                          <i className="fi-rs-shuffle" />
                        </a>
                        <a
                          aria-label="Quick view"
                          className="action-btn"
                          data-bs-toggle="modal"
                          data-bs-target="#quickViewModal"
                        >
                          <i className="fi-rs-eye" />
                        </a>
                      </div>
                      <div className="product-badges product-badges-position product-badges-mrg">
                        <span className="hot">Hot</span>
                      </div>
                    </div>
                    <div className="product-content-wrap">
                      <div className="product-category">
                        <a>Snack</a>
                      </div>
                      <h2>
                        <a>Seeds of Change Organic Quinoe</a>
                      </h2>
                      <div className="product-rate-cover">
                        <div className="product-rate d-inline-block">
                          <div
                            className="product-rating"
                            style={{ width: "90%" }}
                          />
                        </div>
                        <span className="font-small ml-5 text-muted">
                          {" "}
                          (4.0)
                        </span>
                      </div>
                      <div>
                        <span className="font-small text-muted">
                          By <a>NestFood</a>
                        </span>
                      </div>
                      <div className="product-card-bottom">
                        <div className="product-price">
                          <span>$28.85</span>
                          <span className="old-price">$32.8</span>
                        </div>
                        <div className="add-cart">
                          <a className="add">
                            <i className="fi-rs-shopping-cart mr-5" />
                            Add
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/*end product card*/}
                <div className="col-lg-1-5 col-md-4 col-12 col-sm-6">
                  <div className="product-cart-wrap mb-30">
                    <div className="product-img-action-wrap">
                      <div className="product-img product-img-zoom">
                        <a>
                          <img
                            className="default-img"
                            src="assets/imgs/shop/product-2-1.jpg"
                            alt=""
                          />
                          <img
                            className="hover-img"
                            src="assets/imgs/shop/product-2-2.jpg"
                            alt=""
                          />
                        </a>
                      </div>
                      <div className="product-action-1">
                        <a aria-label="Add To Wishlist" className="action-btn">
                          <i className="fi-rs-heart" />
                        </a>
                        <a aria-label="Compare" className="action-btn">
                          <i className="fi-rs-shuffle" />
                        </a>
                        <a
                          aria-label="Quick view"
                          className="action-btn"
                          data-bs-toggle="modal"
                          data-bs-target="#quickViewModal"
                        >
                          <i className="fi-rs-eye" />
                        </a>
                      </div>
                      <div className="product-badges product-badges-position product-badges-mrg">
                        <span className="sale">Sale</span>
                      </div>
                    </div>
                    <div className="product-content-wrap">
                      <div className="product-category">
                        <a>Hodo Foods</a>
                      </div>
                      <h2>
                        <a>All Natural Italian-Style Chicken Meatballs</a>
                      </h2>
                      <div className="product-rate-cover">
                        <div className="product-rate d-inline-block">
                          <div
                            className="product-rating"
                            style={{ width: "80%" }}
                          />
                        </div>
                        <span className="font-small ml-5 text-muted">
                          {" "}
                          (3.5)
                        </span>
                      </div>
                      <div>
                        <span className="font-small text-muted">
                          By <a>Stouffer</a>
                        </span>
                      </div>
                      <div className="product-card-bottom">
                        <div className="product-price">
                          <span>$52.85</span>
                          <span className="old-price">$55.8</span>
                        </div>
                        <div className="add-cart">
                          <a className="add">
                            <i className="fi-rs-shopping-cart mr-5" />
                            Add
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/*end product card*/}
                <div className="col-lg-1-5 col-md-4 col-12 col-sm-6">
                  <div className="product-cart-wrap mb-30">
                    <div className="product-img-action-wrap">
                      <div className="product-img product-img-zoom">
                        <a>
                          <img
                            className="default-img"
                            src="assets/imgs/shop/product-3-1.jpg"
                            alt=""
                          />
                          <img
                            className="hover-img"
                            src="assets/imgs/shop/product-3-2.jpg"
                            alt=""
                          />
                        </a>
                      </div>
                      <div className="product-action-1">
                        <a aria-label="Add To Wishlist" className="action-btn">
                          <i className="fi-rs-heart" />
                        </a>
                        <a aria-label="Compare" className="action-btn">
                          <i className="fi-rs-shuffle" />
                        </a>
                        <a
                          aria-label="Quick view"
                          className="action-btn"
                          data-bs-toggle="modal"
                          data-bs-target="#quickViewModal"
                        >
                          <i className="fi-rs-eye" />
                        </a>
                      </div>
                      <div className="product-badges product-badges-position product-badges-mrg">
                        <span className="new">New</span>
                      </div>
                    </div>
                    <div className="product-content-wrap">
                      <div className="product-category">
                        <a>Snack</a>
                      </div>
                      <h2>
                        <a>Angie’s Boomchickapop Sweet &amp; Salty</a>
                      </h2>
                      <div className="product-rate-cover">
                        <div className="product-rate d-inline-block">
                          <div
                            className="product-rating"
                            style={{ width: "85%" }}
                          />
                        </div>
                        <span className="font-small ml-5 text-muted">
                          {" "}
                          (4.0)
                        </span>
                      </div>
                      <div>
                        <span className="font-small text-muted">
                          By <a>StarKist</a>
                        </span>
                      </div>
                      <div className="product-card-bottom">
                        <div className="product-price">
                          <span>$48.85</span>
                          <span className="old-price">$52.8</span>
                        </div>
                        <div className="add-cart">
                          <a className="add">
                            <i className="fi-rs-shopping-cart mr-5" />
                            Add
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/*end product card*/}
                <div className="col-lg-1-5 col-md-4 col-12 col-sm-6">
                  <div className="product-cart-wrap mb-30">
                    <div className="product-img-action-wrap">
                      <div className="product-img product-img-zoom">
                        <a>
                          <img
                            className="default-img"
                            src="assets/imgs/shop/product-4-1.jpg"
                            alt=""
                          />
                          <img
                            className="hover-img"
                            src="assets/imgs/shop/product-4-2.jpg"
                            alt=""
                          />
                        </a>
                      </div>
                      <div className="product-action-1">
                        <a aria-label="Add To Wishlist" className="action-btn">
                          <i className="fi-rs-heart" />
                        </a>
                        <a aria-label="Compare" className="action-btn">
                          <i className="fi-rs-shuffle" />
                        </a>
                        <a
                          aria-label="Quick view"
                          className="action-btn"
                          data-bs-toggle="modal"
                          data-bs-target="#quickViewModal"
                        >
                          <i className="fi-rs-eye" />
                        </a>
                      </div>
                    </div>
                    <div className="product-content-wrap">
                      <div className="product-category">
                        <a>Vegetables</a>
                      </div>
                      <h2>
                        <a>Foster Farms Takeout Crispy Classic</a>
                      </h2>
                      <div className="product-rate-cover">
                        <div className="product-rate d-inline-block">
                          <div
                            className="product-rating"
                            style={{ width: "90%" }}
                          />
                        </div>
                        <span className="font-small ml-5 text-muted">
                          {" "}
                          (4.0)
                        </span>
                      </div>
                      <div>
                        <span className="font-small text-muted">
                          By <a>NestFood</a>
                        </span>
                      </div>
                      <div className="product-card-bottom">
                        <div className="product-price">
                          <span>$17.85</span>
                          <span className="old-price">$19.8</span>
                        </div>
                        <div className="add-cart">
                          <a className="add">
                            <i className="fi-rs-shopping-cart mr-5" />
                            Add
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/*end product card*/}
                <div className="col-lg-1-5 col-md-4 col-12 col-sm-6">
                  <div className="product-cart-wrap mb-30">
                    <div className="product-img-action-wrap">
                      <div className="product-img product-img-zoom">
                        <a>
                          <img
                            className="default-img"
                            src="assets/imgs/shop/product-5-1.jpg"
                            alt=""
                          />
                          <img
                            className="hover-img"
                            src="assets/imgs/shop/product-5-2.jpg"
                            alt=""
                          />
                        </a>
                      </div>
                      <div className="product-action-1">
                        <a aria-label="Add To Wishlist" className="action-btn">
                          <i className="fi-rs-heart" />
                        </a>
                        <a aria-label="Compare" className="action-btn">
                          <i className="fi-rs-shuffle" />
                        </a>
                        <a
                          aria-label="Quick view"
                          className="action-btn"
                          data-bs-toggle="modal"
                          data-bs-target="#quickViewModal"
                        >
                          <i className="fi-rs-eye" />
                        </a>
                      </div>
                      <div className="product-badges product-badges-position product-badges-mrg">
                        <span className="best">-14%</span>
                      </div>
                    </div>
                    <div className="product-content-wrap">
                      <div className="product-category">
                        <a>Pet Foods</a>
                      </div>
                      <h2>
                        <a>Blue Diamond Almonds Lightly</a>
                      </h2>
                      <div className="product-rate-cover">
                        <div className="product-rate d-inline-block">
                          <div
                            className="product-rating"
                            style={{ width: "90%" }}
                          />
                        </div>
                        <span className="font-small ml-5 text-muted">
                          {" "}
                          (4.0)
                        </span>
                      </div>
                      <div>
                        <span className="font-small text-muted">
                          By <a>NestFood</a>
                        </span>
                      </div>
                      <div className="product-card-bottom">
                        <div className="product-price">
                          <span>$23.85</span>
                          <span className="old-price">$25.8</span>
                        </div>
                        <div className="add-cart">
                          <a className="add">
                            <i className="fi-rs-shopping-cart mr-5" />
                            Add
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/*end product card*/}
                <div className="col-lg-1-5 col-md-4 col-12 col-sm-6">
                  <div className="product-cart-wrap mb-30">
                    <div className="product-img-action-wrap">
                      <div className="product-img product-img-zoom">
                        <a>
                          <img
                            className="default-img"
                            src="assets/imgs/shop/product-6-1.jpg"
                            alt=""
                          />
                          <img
                            className="hover-img"
                            src="assets/imgs/shop/product-6-2.jpg"
                            alt=""
                          />
                        </a>
                      </div>
                      <div className="product-action-1">
                        <a aria-label="Add To Wishlist" className="action-btn">
                          <i className="fi-rs-heart" />
                        </a>
                        <a aria-label="Compare" className="action-btn">
                          <i className="fi-rs-shuffle" />
                        </a>
                        <a
                          aria-label="Quick view"
                          className="action-btn"
                          data-bs-toggle="modal"
                          data-bs-target="#quickViewModal"
                        >
                          <i className="fi-rs-eye" />
                        </a>
                      </div>
                    </div>
                    <div className="product-content-wrap">
                      <div className="product-category">
                        <a>Hodo Foods</a>
                      </div>
                      <h2>
                        <a>Chobani Complete Vanilla Greek</a>
                      </h2>
                      <div className="product-rate-cover">
                        <div className="product-rate d-inline-block">
                          <div
                            className="product-rating"
                            style={{ width: "90%" }}
                          />
                        </div>
                        <span className="font-small ml-5 text-muted">
                          {" "}
                          (4.0)
                        </span>
                      </div>
                      <div>
                        <span className="font-small text-muted">
                          By <a>NestFood</a>
                        </span>
                      </div>
                      <div className="product-card-bottom">
                        <div className="product-price">
                          <span>$54.85</span>
                          <span className="old-price">$55.8</span>
                        </div>
                        <div className="add-cart">
                          <a className="add">
                            <i className="fi-rs-shopping-cart mr-5" />
                            Add
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/*end product card*/}
                <div className="col-lg-1-5 col-md-4 col-12 col-sm-6">
                  <div className="product-cart-wrap mb-30">
                    <div className="product-img-action-wrap">
                      <div className="product-img product-img-zoom">
                        <a>
                          <img
                            className="default-img"
                            src="assets/imgs/shop/product-7-1.jpg"
                            alt=""
                          />
                          <img
                            className="hover-img"
                            src="assets/imgs/shop/product-7-2.jpg"
                            alt=""
                          />
                        </a>
                      </div>
                      <div className="product-action-1">
                        <a aria-label="Add To Wishlist" className="action-btn">
                          <i className="fi-rs-heart" />
                        </a>
                        <a aria-label="Compare" className="action-btn">
                          <i className="fi-rs-shuffle" />
                        </a>
                        <a
                          aria-label="Quick view"
                          className="action-btn"
                          data-bs-toggle="modal"
                          data-bs-target="#quickViewModal"
                        >
                          <i className="fi-rs-eye" />
                        </a>
                      </div>
                    </div>
                    <div className="product-content-wrap">
                      <div className="product-category">
                        <a>Meats</a>
                      </div>
                      <h2>
                        <a>Canada Dry Ginger Ale – 2 L Bottle</a>
                      </h2>
                      <div className="product-rate-cover">
                        <div className="product-rate d-inline-block">
                          <div
                            className="product-rating"
                            style={{ width: "90%" }}
                          />
                        </div>
                        <span className="font-small ml-5 text-muted">
                          {" "}
                          (4.0)
                        </span>
                      </div>
                      <div>
                        <span className="font-small text-muted">
                          By <a>NestFood</a>
                        </span>
                      </div>
                      <div className="product-card-bottom">
                        <div className="product-price">
                          <span>$32.85</span>
                          <span className="old-price">$33.8</span>
                        </div>
                        <div className="add-cart">
                          <a className="add">
                            <i className="fi-rs-shopping-cart mr-5" />
                            Add
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/*end product card*/}
                <div className="col-lg-1-5 col-md-4 col-12 col-sm-6">
                  <div className="product-cart-wrap mb-30">
                    <div className="product-img-action-wrap">
                      <div className="product-img product-img-zoom">
                        <a>
                          <img
                            className="default-img"
                            src="assets/imgs/shop/product-8-1.jpg"
                            alt=""
                          />
                          <img
                            className="hover-img"
                            src="assets/imgs/shop/product-8-2.jpg"
                            alt=""
                          />
                        </a>
                      </div>
                      <div className="product-action-1">
                        <a aria-label="Add To Wishlist" className="action-btn">
                          <i className="fi-rs-heart" />
                        </a>
                        <a aria-label="Compare" className="action-btn">
                          <i className="fi-rs-shuffle" />
                        </a>
                        <a
                          aria-label="Quick view"
                          className="action-btn"
                          data-bs-toggle="modal"
                          data-bs-target="#quickViewModal"
                        >
                          <i className="fi-rs-eye" />
                        </a>
                      </div>
                      <div className="product-badges product-badges-position product-badges-mrg">
                        <span className="sale">Sale</span>
                      </div>
                    </div>
                    <div className="product-content-wrap">
                      <div className="product-category">
                        <a>Snack</a>
                      </div>
                      <h2>
                        <a>Encore Seafoods Stuffed Alaskan</a>
                      </h2>
                      <div className="product-rate-cover">
                        <div className="product-rate d-inline-block">
                          <div
                            className="product-rating"
                            style={{ width: "90%" }}
                          />
                        </div>
                        <span className="font-small ml-5 text-muted">
                          {" "}
                          (4.0)
                        </span>
                      </div>
                      <div>
                        <span className="font-small text-muted">
                          By <a>NestFood</a>
                        </span>
                      </div>
                      <div className="product-card-bottom">
                        <div className="product-price">
                          <span>$35.85</span>
                          <span className="old-price">$37.8</span>
                        </div>
                        <div className="add-cart">
                          <a className="add">
                            <i className="fi-rs-shopping-cart mr-5" />
                            Add
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/*end product card*/}
                <div className="col-lg-1-5 col-md-4 col-12 col-sm-6">
                  <div className="product-cart-wrap mb-30">
                    <div className="product-img-action-wrap">
                      <div className="product-img product-img-zoom">
                        <a>
                          <img
                            className="default-img"
                            src="assets/imgs/shop/product-9-1.jpg"
                            alt=""
                          />
                          <img
                            className="hover-img"
                            src="assets/imgs/shop/product-9-2.jpg"
                            alt=""
                          />
                        </a>
                      </div>
                      <div className="product-action-1">
                        <a aria-label="Add To Wishlist" className="action-btn">
                          <i className="fi-rs-heart" />
                        </a>
                        <a aria-label="Compare" className="action-btn">
                          <i className="fi-rs-shuffle" />
                        </a>
                        <a
                          aria-label="Quick view"
                          className="action-btn"
                          data-bs-toggle="modal"
                          data-bs-target="#quickViewModal"
                        >
                          <i className="fi-rs-eye" />
                        </a>
                      </div>
                      <div className="product-badges product-badges-position product-badges-mrg">
                        <span className="hot">Hot</span>
                      </div>
                    </div>
                    <div className="product-content-wrap">
                      <div className="product-category">
                        <a>Coffes</a>
                      </div>
                      <h2>
                        <a>Gorton’s Beer Battered Fish Fillets</a>
                      </h2>
                      <div className="product-rate-cover">
                        <div className="product-rate d-inline-block">
                          <div
                            className="product-rating"
                            style={{ width: "90%" }}
                          />
                        </div>
                        <span className="font-small ml-5 text-muted">
                          {" "}
                          (4.0)
                        </span>
                      </div>
                      <div>
                        <span className="font-small text-muted">
                          By
                          <a>Old El Paso</a>
                        </span>
                      </div>
                      <div className="product-card-bottom">
                        <div className="product-price">
                          <span>$23.85</span>
                          <span className="old-price">$25.8</span>
                        </div>
                        <div className="add-cart">
                          <a className="add">
                            <i className="fi-rs-shopping-cart mr-5" />
                            Add
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/*end product card*/}
                <div className="col-lg-1-5 col-md-4 col-12 col-sm-6 d-none d-xl-block">
                  <div className="product-cart-wrap">
                    <div className="product-img-action-wrap">
                      <div className="product-img product-img-zoom">
                        <a>
                          <img
                            className="default-img"
                            src="assets/imgs/shop/product-10-1.jpg"
                            alt=""
                          />
                          <img
                            className="hover-img"
                            src="assets/imgs/shop/product-10-2.jpg"
                            alt=""
                          />
                        </a>
                      </div>
                      <div className="product-action-1">
                        <a aria-label="Add To Wishlist" className="action-btn">
                          <i className="fi-rs-heart" />
                        </a>
                        <a aria-label="Compare" className="action-btn">
                          <i className="fi-rs-shuffle" />
                        </a>
                        <a
                          aria-label="Quick view"
                          className="action-btn"
                          data-bs-toggle="modal"
                          data-bs-target="#quickViewModal"
                        >
                          <i className="fi-rs-eye" />
                        </a>
                      </div>
                    </div>
                    <div className="product-content-wrap">
                      <div className="product-category">
                        <a>Cream</a>
                      </div>
                      <h2>
                        <a>Haagen-Dazs Caramel Cone Ice Cream</a>
                      </h2>
                      <div className="product-rate-cover">
                        <div className="product-rate d-inline-block">
                          <div
                            className="product-rating"
                            style={{ width: "50%" }}
                          />
                        </div>
                        <span className="font-small ml-5 text-muted">
                          {" "}
                          (2.0)
                        </span>
                      </div>
                      <div>
                        <span className="font-small text-muted">
                          By <a>Tyson</a>
                        </span>
                      </div>
                      <div className="product-card-bottom">
                        <div className="product-price">
                          <span>$22.85</span>
                          <span className="old-price">$24.8</span>
                        </div>
                        <div className="add-cart">
                          <a className="add">
                            <i className="fi-rs-shopping-cart mr-5" />
                            Add
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/*end product card*/}
              </div>
              {/*product grid*/}
              <div className="pagination-area mt-20 mb-20">
                <nav aria-label="Page navigation example">
                  <ul className="pagination justify-content-start">
                    <li className="page-item">
                      <a className="page-link">
                        <i className="fi-rs-arrow-small-left" />
                      </a>
                    </li>
                    <li className="page-item">
                      <a className="page-link">1</a>
                    </li>
                    <li className="page-item active">
                      <a className="page-link">2</a>
                    </li>
                    <li className="page-item">
                      <a className="page-link">3</a>
                    </li>
                    <li className="page-item">
                      <a className="page-link dot">...</a>
                    </li>
                    <li className="page-item">
                      <a className="page-link">6</a>
                    </li>
                    <li className="page-item">
                      <a className="page-link">
                        <i className="fi-rs-arrow-small-right" />
                      </a>
                    </li>
                  </ul>
                </nav>
              </div>
              <section className="section-padding pb-5">
                <div className="section-title">
                  <h3 className="">Deals Of The Day</h3>
                  <a className="show-all">
                    All Deals
                    <i className="fi-rs-angle-right" />
                  </a>
                </div>
                <div className="row">
                  <div className="col-xl-3 col-lg-4 col-md-6">
                    <div className="product-cart-wrap style-2">
                      <div className="product-img-action-wrap">
                        <div className="product-img">
                          <a>
                            <img src="assets/imgs/banner/banner-5.png" alt="" />
                          </a>
                        </div>
                      </div>
                      <div className="product-content-wrap">
                        <div className="deals-countdown-wrap">
                          <div
                            className="deals-countdown"
                            data-countdown="2025/03/25 00:00:00"
                          />
                        </div>
                        <div className="deals-content">
                          <h2>
                            <a>Seeds of Change Organic Quinoa, Brown</a>
                          </h2>
                          <div className="product-rate-cover">
                            <div className="product-rate d-inline-block">
                              <div
                                className="product-rating"
                                style={{ width: "90%" }}
                              />
                            </div>
                            <span className="font-small ml-5 text-muted">
                              {" "}
                              (4.0)
                            </span>
                          </div>
                          <div>
                            <span className="font-small text-muted">
                              By
                              <a>NestFood</a>
                            </span>
                          </div>
                          <div className="product-card-bottom">
                            <div className="product-price">
                              <span>$32.85</span>
                              <span className="old-price">$33.8</span>
                            </div>
                            <div className="add-cart">
                              <a className="add">
                                <i className="fi-rs-shopping-cart mr-5" />
                                Add
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-3 col-lg-4 col-md-6">
                    <div className="product-cart-wrap style-2">
                      <div className="product-img-action-wrap">
                        <div className="product-img">
                          <a>
                            <img src="assets/imgs/banner/banner-6.png" alt="" />
                          </a>
                        </div>
                      </div>
                      <div className="product-content-wrap">
                        <div className="deals-countdown-wrap">
                          <div
                            className="deals-countdown"
                            data-countdown="2026/04/25 00:00:00"
                          />
                        </div>
                        <div className="deals-content">
                          <h2>
                            <a>Perdue Simply Smart Organics Gluten</a>
                          </h2>
                          <div className="product-rate-cover">
                            <div className="product-rate d-inline-block">
                              <div
                                className="product-rating"
                                style={{ width: "90%" }}
                              />
                            </div>
                            <span className="font-small ml-5 text-muted">
                              {" "}
                              (4.0)
                            </span>
                          </div>
                          <div>
                            <span className="font-small text-muted">
                              By
                              <a>Old El Paso</a>
                            </span>
                          </div>
                          <div className="product-card-bottom">
                            <div className="product-price">
                              <span>$24.85</span>
                              <span className="old-price">$26.8</span>
                            </div>
                            <div className="add-cart">
                              <a className="add">
                                <i className="fi-rs-shopping-cart mr-5" />
                                Add
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-3 col-lg-4 col-md-6 d-none d-lg-block">
                    <div className="product-cart-wrap style-2">
                      <div className="product-img-action-wrap">
                        <div className="product-img">
                          <a>
                            <img src="assets/imgs/banner/banner-7.png" alt="" />
                          </a>
                        </div>
                      </div>
                      <div className="product-content-wrap">
                        <div className="deals-countdown-wrap">
                          <div
                            className="deals-countdown"
                            data-countdown="2027/03/25 00:00:00"
                          />
                        </div>
                        <div className="deals-content">
                          <h2>
                            <a>Signature Wood-Fired Mushroom</a>
                          </h2>
                          <div className="product-rate-cover">
                            <div className="product-rate d-inline-block">
                              <div
                                className="product-rating"
                                style={{ width: "80%" }}
                              />
                            </div>
                            <span className="font-small ml-5 text-muted">
                              {" "}
                              (3.0)
                            </span>
                          </div>
                          <div>
                            <span className="font-small text-muted">
                              By
                              <a>Progresso</a>
                            </span>
                          </div>
                          <div className="product-card-bottom">
                            <div className="product-price">
                              <span>$12.85</span>
                              <span className="old-price">$13.8</span>
                            </div>
                            <div className="add-cart">
                              <a className="add">
                                <i className="fi-rs-shopping-cart mr-5" />
                                Add
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-3 col-lg-4 col-md-6 d-none d-xl-block">
                    <div className="product-cart-wrap style-2">
                      <div className="product-img-action-wrap">
                        <div className="product-img">
                          <a>
                            <img src="assets/imgs/banner/banner-8.png" alt="" />
                          </a>
                        </div>
                      </div>
                      <div className="product-content-wrap">
                        <div className="deals-countdown-wrap">
                          <div
                            className="deals-countdown"
                            data-countdown="2025/02/25 00:00:00"
                          />
                        </div>
                        <div className="deals-content">
                          <h2>
                            <a>Simply Lemonade with Raspberry Juice</a>
                          </h2>
                          <div className="product-rate-cover">
                            <div className="product-rate d-inline-block">
                              <div
                                className="product-rating"
                                style={{ width: "80%" }}
                              />
                            </div>
                            <span className="font-small ml-5 text-muted">
                              {" "}
                              (3.0)
                            </span>
                          </div>
                          <div>
                            <span className="font-small text-muted">
                              By
                              <a>Yoplait</a>
                            </span>
                          </div>
                          <div className="product-card-bottom">
                            <div className="product-price">
                              <span>$15.85</span>
                              <span className="old-price">$16.8</span>
                            </div>
                            <div className="add-cart">
                              <a className="add">
                                <i className="fi-rs-shopping-cart mr-5" />
                                Add
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              {/*End Deals*/}
            </div>
            <div className="col-lg-1-5 primary-sidebar sticky-sidebar">
              <div className="sidebar-widget widget-store-info mb-30 bg-3 border-0">
                <div className="vendor-logo mb-30">
                  <img src="assets/imgs/vendor/vendor-16.png" alt="" />
                </div>
                <div className="vendor-info">
                  <div className="product-category">
                    <span className="text-muted">Since 2012</span>
                  </div>
                  <h4 className="mb-5">
                    <a className="text-heading">Nest Food.,Ltd</a>
                  </h4>
                  <div className="product-rate-cover mb-15">
                    <div className="product-rate d-inline-block">
                      <div
                        className="product-rating"
                        style={{ width: "90%" }}
                      />
                    </div>
                    <span className="font-small ml-5 text-muted"> (4.0)</span>
                  </div>
                  <div className="vendor-des mb-30">
                    <p className="font-sm text-heading">
                      Got a smooth, buttery spread in your fridge? Chances are
                      good that it's Good Chef. This brand made Lionto's list of
                      the most popular grocery brands across the country.
                    </p>
                  </div>
                  <div className="follow-social mb-20">
                    <h6 className="mb-15">Follow Us</h6>
                    <ul className="social-network">
                      <li className="hover-up">
                        <a>
                          <img
                            src="assets/imgs/theme/icons/social-tw.svg"
                            alt=""
                          />
                        </a>
                      </li>
                      <li className="hover-up">
                        <a>
                          <img
                            src="assets/imgs/theme/icons/social-fb.svg"
                            alt=""
                          />
                        </a>
                      </li>
                      <li className="hover-up">
                        <a>
                          <img
                            src="assets/imgs/theme/icons/social-insta.svg"
                            alt=""
                          />
                        </a>
                      </li>
                      <li className="hover-up">
                        <a>
                          <img
                            src="assets/imgs/theme/icons/social-pin.svg"
                            alt=""
                          />
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div className="vendor-info">
                    <ul className="font-sm mb-20">
                      <li>
                        <img
                          className="mr-5"
                          src="assets/imgs/theme/icons/icon-location.svg"
                          alt=""
                        />
                        <strong>Address: </strong>
                        <span>
                          5171 W Campbell Ave undefined, Utah 53127 United
                          States
                        </span>
                      </li>
                      <li>
                        <img
                          className="mr-5"
                          src="assets/imgs/theme/icons/icon-contact.svg"
                          alt=""
                        />
                        <strong>Call Us:</strong>
                        <span>(+91) - 540-025-124553</span>
                      </li>
                    </ul>
                    <a className="btn btn-xs">
                      Contact Seller <i className="fi-rs-arrow-small-right" />
                    </a>
                  </div>
                </div>
              </div>
              <div className="sidebar-widget widget-category-2 mb-30">
                <h5 className="section-title style-1 mb-30">Category</h5>
                <ul>
                  <li>
                    <a>
                      <img
                        src="assets/imgs/theme/icons/category-1.svg"
                        alt=""
                      />
                      Milks &amp; Dairies
                    </a>
                    <span className="count">30</span>
                  </li>
                  <li>
                    <a>
                      <img
                        src="assets/imgs/theme/icons/category-2.svg"
                        alt=""
                      />
                      Clothing
                    </a>
                    <span className="count">35</span>
                  </li>
                  <li>
                    <a>
                      <img
                        src="assets/imgs/theme/icons/category-3.svg"
                        alt=""
                      />
                      Pet Foods{" "}
                    </a>
                    <span className="count">42</span>
                  </li>
                  <li>
                    <a>
                      <img
                        src="assets/imgs/theme/icons/category-4.svg"
                        alt=""
                      />
                      Baking material
                    </a>
                    <span className="count">68</span>
                  </li>
                  <li>
                    <a>
                      <img
                        src="assets/imgs/theme/icons/category-5.svg"
                        alt=""
                      />
                      Fresh Fruit
                    </a>
                    <span className="count">87</span>
                  </li>
                </ul>
              </div>
              {/* Fillter By Price */}
              <div className="sidebar-widget price_range range mb-30">
                <h5 className="section-title style-1 mb-30">Fill by price</h5>
                <div className="price-filter">
                  <div className="price-filter-inner">
                    <div id="slider-range" className="mb-20" />
                    <div className="d-flex justify-content-between">
                      <div className="caption">
                        From:
                        <strong
                          id="slider-range-value1"
                          className="text-brand"
                        />
                      </div>
                      <div className="caption">
                        To:
                        <strong
                          id="slider-range-value2"
                          className="text-brand"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="list-group">
                  <div className="list-group-item mb-10 mt-10">
                    <label className="fw-900">Color</label>
                    <div className="custome-checkbox">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        name="checkbox"
                        id="exampleCheckbox1"
                        defaultValue=""
                      />
                      <label
                        className="form-check-label"
                        htmlFor="exampleCheckbox1"
                      >
                        <span>Red (56)</span>
                      </label>
                      <br />
                      <input
                        className="form-check-input"
                        type="checkbox"
                        name="checkbox"
                        id="exampleCheckbox2"
                        defaultValue=""
                      />
                      <label
                        className="form-check-label"
                        htmlFor="exampleCheckbox2"
                      >
                        <span>Green (78)</span>
                      </label>
                      <br />
                      <input
                        className="form-check-input"
                        type="checkbox"
                        name="checkbox"
                        id="exampleCheckbox3"
                        defaultValue=""
                      />
                      <label
                        className="form-check-label"
                        htmlFor="exampleCheckbox3"
                      >
                        <span>Blue (54)</span>
                      </label>
                    </div>
                    <label className="fw-900 mt-15">Item Condition</label>
                    <div className="custome-checkbox">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        name="checkbox"
                        id="exampleCheckbox11"
                        defaultValue=""
                      />
                      <label
                        className="form-check-label"
                        htmlFor="exampleCheckbox11"
                      >
                        <span>New (1506)</span>
                      </label>
                      <br />
                      <input
                        className="form-check-input"
                        type="checkbox"
                        name="checkbox"
                        id="exampleCheckbox21"
                        defaultValue=""
                      />
                      <label
                        className="form-check-label"
                        htmlFor="exampleCheckbox21"
                      >
                        <span>Refurbished (27)</span>
                      </label>
                      <br />
                      <input
                        className="form-check-input"
                        type="checkbox"
                        name="checkbox"
                        id="exampleCheckbox31"
                        defaultValue=""
                      />
                      <label
                        className="form-check-label"
                        htmlFor="exampleCheckbox31"
                      >
                        <span>Used (45)</span>
                      </label>
                    </div>
                  </div>
                </div>
                <a className="btn btn-sm btn-default">
                  <i className="fi-rs-filter mr-5" /> Fillter
                </a>
              </div>
              <div className="banner-img wow fadeIn mb-lg-0 animated d-lg-block d-none">
                <img src="assets/imgs/banner/banner-11.png" alt="" />
                <div className="banner-text">
                  <span>Oganic</span>
                  <h4>
                    Save 17% <br />
                    on <span className="text-brand">Oganic</span>
                    <br />
                    Juice
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
